import { useCallback, useMemo } from 'react';
import { useCompanyLevels } from './useCompanies';

// useCompanyLevelName resolves company level UUIDs to their translated display names using
// the shared company levels cache. Returns undefined while the levels are still loading or
// when the id is unknown, so callers can decide how to render the gap.
export function useCompanyLevelName() {
  const { data: levels = [] } = useCompanyLevels(null);
  const levelNameById = useMemo(() => new Map(levels.map((level) => [level.id, level.name])), [levels]);

  const resolveLevelName = useCallback(
    (levelId: string | undefined | null): string | undefined => (levelId ? levelNameById.get(levelId) : undefined),
    [levelNameById]
  );

  return { resolveLevelName };
}
